import React, { useEffect } from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { LookInsideCarousel } from './components/LookInsideCarousel';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { UrgencySection } from './components/UrgencySection';
import { productShortName } from './data/offer';
const pageDescription = 'La collezione completa in 6 volumi + 5 bonus per insegnare geologia in modo chiaro, visivo e pronto per la classe.';
export function App() {
  useEffect(() => {
    document.documentElement.lang = 'it';
    document.title = productShortName;
    const setMeta = (attr: 'name' | 'property', key: string, content: string) => {
      let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };
    setMeta('name', 'description', pageDescription);
    setMeta('property', 'og:title', productShortName);
    setMeta('property', 'og:description', pageDescription);
  }, []);
  return <div className="min-h-screen w-full overflow-hidden bg-slate-950 font-sans text-slate-300 antialiased" data-id="element-0" data-mp="nuhgse7ce3s6">
      <MetaPixel data-id="element-1" data-mp="stc864jdl0nw" />
      <main data-id="element-2" data-mp="sssqmoxn0eae">
        <Hero data-id="element-3" data-mp="swqbbezv5dwe" />
        <LookInsideCarousel data-id="element-4" data-mp="36hv93iy4lzn" />
        <ProblemSection data-id="element-5" data-mp="35oxgs1yt6tn" />
        <SystemSection data-id="element-6" data-mp="34x13f0jn52b" />
        <ModulesSection data-id="element-7" data-mp="38ktuby5znfz" />
        <BonusSection data-id="element-8" data-mp="3ud1ff9ao9oam" />
        <UrgencySection data-id="element-9" data-mp="3ubrfeek9e61c" />
        <PricingSection data-id="element-10" data-mp="3uc9inv5c9kir" />
        <GuaranteeSection data-id="element-11" data-mp="3uf5hdlp0gd89" />
        <FAQ data-id="element-12" data-mp="d57h17dyqql6" />
        <ClosingSection data-id="element-13" data-mp="d4xmd6hz3v95" />
        <SummaryTable data-id="element-14" data-mp="d45uo6rhyho5" />
        <FinalCta data-id="element-15" data-mp="d2biphy7dzw7" />
      </main>
      <Footer data-id="element-16" data-mp="851lvh8hilyc" />
      <PurchaseNotification data-id="element-17" data-mp="86mfn4mz60v5" />
    </div>;
}